var _circle, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForgotLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 151,
    viewBox: "0 0 150 151",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75.9688,
    r: 74,
    stroke: "url(#paint0_linear_9_643)",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.1758 69.4087V64.3333C59.1758 55.9335 61.8889 49.1071 75.4547 49.1071C89.0205 49.1071 91.7336 55.9335 91.7336 64.3333V69.4087",
    stroke: "url(#paint1_linear_9_643)",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9587 92.4796C79.7047 92.4796 82.7415 89.6391 82.7415 86.1353C82.7415 82.6314 79.7047 79.791 75.9587 79.791C72.2126 79.791 69.1758 82.6314 69.1758 86.1353C69.1758 89.6391 72.2126 92.4796 75.9587 92.4796Z",
    stroke: "url(#paint2_linear_9_643)",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4258 103.216H63.9258C54.5258 103.216 52.1758 100.405 52.1758 89.1611V83.5391C52.1758 72.2951 54.5258 69.4841 63.9258 69.4841H87.4258C96.8258 69.4841 99.1758 72.2951 99.1758 83.5391V89.1611C99.1758 100.405 96.8258 103.216 87.4258 103.216Z",
    stroke: "url(#paint3_linear_9_643)",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_643",
    x1: 75,
    y1: 0.968751,
    x2: 110.481,
    y2: 192.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A175FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#563AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9_643",
    x1: 75.4547,
    y1: 49.1071,
    x2: 78.5109,
    y2: 75.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A175FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#563AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9_643",
    x1: 75.9587,
    y1: 79.791,
    x2: 78.7776,
    y2: 96.0925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A175FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#563AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9_643",
    x1: 75.6758,
    y1: 69.4841,
    x2: 81.4956,
    y2: 113.345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A175FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#563AFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgotLogo);
export default __webpack_public_path__ + "static/media/ForgotLogo.a97be73f6fc6d9ab62a0b698b77ccc66.svg";
export { ForwardRef as ReactComponent };